import React from 'react'
import styled from 'styled-components'
import Content from './Content'

const HeroContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 440px;
  background-color: #212c34;
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center center;
  color: #fff;
  font-size: 26px;
  line-height: 38px;
  padding: 90px 0;
`

const Inner = styled.div`
  max-width: 1060px;
  margin: 0 20px;

  h2,
  h3 {
    color: ${(props) => props.theme.colors.white} !important;
  }
`

const Hero = ({ children, image }) => {
  return (
    <HeroContainer image={image}>
      <Inner>
        <Content>{children}</Content>
      </Inner>
    </HeroContainer>
  )
}

export default Hero
